import BaseCommand from "../BaseCommand";

export default class CreateFlowReportCommand extends BaseCommand {
    public startDateTime: Date | null
    public endDateTime: Date | null
    public campaignId: string
    public campaignName: string
    public flowId: string
    public flowName: string
    public abandoned: boolean | null
    public abandonedReason: string | null
    public additionalReason: string | null
    public abandonedFormName: string | null

    constructor() {
        super()
        this.startDateTime = null;
        this.endDateTime = null;
        this.campaignId = "";
        this.campaignName = "";
        this.flowId = "";
        this.flowName = "";
        this.abandoned = null;
        this.abandonedReason = null;
        this.additionalReason = null;
        this.abandonedFormName = null;
    }

    public getEndpoint(): string {
        return  "conversation/reporting/flow"
    }
}